import React from 'react';
import Img from 'react-cool-img';

import { DateHelper, DEFAULT_DATE_FORMAT } from '@utils/DateHelper';

import { Article } from '@common/domain/models/Article';

import { PlaceholderImage } from '@assets/images';

import Text, { FontFamilyVariant, TextType } from '@components/Text';

import './styles.less';

interface IProps {
   content:Article;
    className?: string;
    onCardClick?:()=>void
}

const FinanceCard = (props: IProps) => {
    const { content, className, onCardClick } = props;
    const showFormattedDate = (date: string) => DateHelper.getDateTime(date as unknown as Date, DEFAULT_DATE_FORMAT);
    const style = ['finance_card_container', className].join(' ');

    return (
        <div
            className={style}
            onClick={onCardClick}
        >
            <div className="shadow">
                <Img
                    className="finance_img"
                    debounce={0}
                    onError=""
                    placeholder={PlaceholderImage}
                    retry={{ count: 0 }}
                    src={content?.getCoverImageUrl() || content?.getOgData()?.image}
                />

            </div>
            <div className="child_container">
                <Text
                    className="finance_time"
                    fontFamilyVariant={FontFamilyVariant.regular1}
                    text={showFormattedDate(content?.getCreatedAt())}
                    textType={TextType.display2}
                />
                <Text
                    className="finance_heading"
                    fontFamilyVariant={FontFamilyVariant.bold3}
                    text={content?.getTitle()}
                    textType={TextType.display2}
                />
            </div>
        </div>
    );
};

export default FinanceCard;
